<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">Edit Album</h1>

        <p class="text-primary-300 text-sm">Edit Album Details</p>

        <form [formGroup]="pageForm" (ngSubmit)="submit()">
            <div class="mt-4 w-full flex flex-col">
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Album Name *
                    </label>
                    <input type="text" formControlName="albumName" name="albumName"
                        class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 text-primary-500 ease-linear transition-all duration-150">
                    <div
                        class="{{ pageForm.get('albumName')?.invalid && (pageForm.get('albumName')?.dirty || pageForm.get('albumName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('albumName')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        } @else if (pageForm.get('albumName')?.errors?.['minlength'] ||
                        pageForm.get('albumName')?.errors?.['maxlength'])
                        {
                        <p>
                            Min {{ pageForm.get('albumName')?.errors?.['minlength']?.requiredLength }} and max {{
                            pageForm.get('albumName')?.errors?.['maxlength']?.requiredLength }} chars
                        </p>
                        }
                    </div>
                </div>
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required
                        class="rounded my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 text-primary-500 ease-linear transition-all duration-150"
                        rows="4"></textarea>
                    <div
                        class="{{ pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('description')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        } @else if (pageForm.get('description')?.errors?.['pattern'])
                        {
                        <p>
                            Only letters allowed
                        </p>
                        } @else if (pageForm.get('description')?.errors?.['minlength'] ||
                        pageForm.get('description')?.errors?.['maxlength'])
                        {
                        <p>
                            Max {{pageForm.get('description')?.errors?.['maxlength']?.requiredLength}} chars
                        </p>
                        }
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-1 w-full mb-2">
                <label class="block uppercase text-blueGray-600 text-xs font-bold">
                    Album Date *
                </label>
                <input type="date" name="albumDate" formControlName="albumDate" placeholder="DD/MM/YYYY"
                    class="rounded-md my-auto outline-none w-full ring-0 focus:outline-none focus:ring-0 placeholder-gray-300 text-primary-500 ease-linear transition-all duration-150">
                <div
                    class="{{ pageForm.get('albumDate')?.invalid && (pageForm.get('albumDate')?.dirty || pageForm.get('albumDate')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                    @if (pageForm.get('albumDate')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    }
                </div>
            </div>

            <div class="flex flex-row gap-4 justify-end">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <app-btn-action (click)="submit()" [inProgress]="(working$ | async) ?? false" label="Update"
                    bgColor="bg-primary-500 hover:bg-primary-300"></app-btn-action>
            </div>
        </form>
    </div>
</div>